export default "__VITE_ASSET__CglskQdH__"